export default __webpack_public_path__ + "static/media/imp2.d8b30800.png";